import React from "react";

/**
 * Time Machine #114 Phase 4 — centered overlay spinner for use INSIDE a
 * schedule/optimizer grid wrapper.
 *
 * Rendered as `position: absolute; inset: 0`, so the parent must be
 * `position: relative`. The overlay is `pointer-events: none` so the user
 * can still scroll the (partially-loaded) grid behind it. A semi-opaque
 * backdrop signals "in flight" without obscuring whatever data is already
 * visible.
 *
 * Per-grid use case (#105 multi-grid Optimizer): each `<OptimizerGrid>`
 * instance renders its own `<GridSpinner>`. Today the time-travel queries
 * share state across all grids (so all spinners turn on/off together), but
 * the per-grid render means the visual signal is correct for whichever
 * subset of grids the user is viewing.
 */
const GridSpinner = ({ show, label = "Loading…" }) => {
  if (!show) return null;
  return (
    <div
      data-testid="grid-spinner"
      // z-50 — must sit above TimeTravelTint (z-40) and the schedule grid's
      // sticky-top header (z-30, #116). When also rendered inside a Modal
      // panel (CrewHistorySection, JobHistorySection, AttributeHistorySection),
      // z-50 just makes the spinner the topmost element within the modal's
      // own stacking context — Modal's backdrop establishes its own context.
      className="absolute inset-0 z-50 flex items-center justify-center pointer-events-none"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.25)" }}
    >
      <div className="flex flex-col items-center gap-3 px-6 py-4 rounded-lg" style={{ backgroundColor: "rgba(0, 0, 0, 0.65)" }}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow"></div>
        <span className="text-skin-primary font-bold text-sm">{label}</span>
      </div>
    </div>
  );
};

export default GridSpinner;
